// MuiDatePicker
import { lightPalette } from "../palette";

export const MuiDatePicker = {
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        "&, .MuiPaper-root": {
          backgroundColor: lightPalette.background.paper,
          backgroundImage: "none",
          color: lightPalette.text.primary,
          "& .MuiPickersDay-root:not(.Mui-selected)": {
            backgroundColor: lightPalette.background.paper,
            color: lightPalette.text.primary,
            "&:hover": {
              backgroundColor: lightPalette.action.hover,
            },
            "&:disabled": {
              opacity: "0.25",
            },
          },
          "& .MuiIconButton-root, .MuiButtonBase-root:not(.Mui-selected)": {
            color: lightPalette.text.primary,
          },
          "& .MuiClockPicker-arrowSwitcher ~ div": {
            "& span": {
              color: lightPalette.text.primary,
            },
          },
        },
      },
    },
  },
  MuiDateTimePicker: {
    styleOverrides: {
      root: {
        "&.MuiTabs-root, & .MuiTabs-root": {
          backgroundCOlor: "red",
        },
        backgroundColor: "red",
        "&, .MuiPaper-root": {
          backgroundColor: "red",
          backgroundImage: "none",
          color: lightPalette.text.primary,
          "& .MuiClockPicker-arrowSwitcher ~ div": {
            "& span": {
              color: lightPalette.text.primary,
            },
          },
        },
      },
    },
  },
};
